import _ from "lodash";
import { useEffect, useState } from "react";
import { Carousel, ProgressBar } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getSelectedCatId,
  showBuyModal,
  getAssignCourse,
  getAssignCourseClear,
  getAssignBrokerCourse,
  getAssignBrokerCourseClear,
  setMarkView,
} from "../../redux/courses/actions";
import {
  recommendationInsertViewData,
  recommendationInsertViewResponse,
  recommendationInsertViewClear,
} from "../../redux/recommendationView/actions";
import { courseDetailResponse } from "../../redux/product/actions";
import { clickStreamUser, SessionKeys, webViewCallbackHandler } from "../../utils/AppUtils";
import BuyProductModal from "../modal/BuyProductModal";
import ConfirmModal from "../modal/ConfirmModal";
import Slider from "react-slick/";
import moment from "moment";
import ImageComponent from "../Layouts/ImageComponent";
import ProviderComponent from "../Layouts/ProviderComponent";
import CONFIG from '../../utils/config';
import useLogin from "../../custom-hooks/useLogin";

const CourseCardListBody = (props) => {
  const {
    coursesList,
    pageType,
    setFavoriteCourse,
    closeModal,
    setCloseModal,
    hasDescription,
    filterData,
    isSearch,
    isMobile
  } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {isLoggedIn} = useLogin()
  
  const auth = useSelector((state) => state.auth);
  const authBroker = useSelector((state) => state.auth.authBroker);
  const selectedCategory = useSelector(
    (state) => state.courses.selectedCategory
  );
  const assignCourse = useSelector((state) => state.courses.assignCourse);
  const assignBrokerCourse = useSelector((state) => state.courses.assignBrokerCourse);

  const [courseData, setCourseData] = useState({});
  const [confirmModal, setConfirmModal] = useState(false);
  const [isConfirm, setIsConfirm] = useState(false);
  const [courseId, setCourseId] = useState("");
  const [showModalMsg] = useState(
    "Are you sure you want to set this course as favorite?"
  );

  const recommendationInsertViewData1 = useSelector(
    (state) => state.recommendationView.recommendationInsertViewData
  );

  const [recommendInsertView, setInsertRecommendView] = useState({});

  useEffect(() => {
    // console.log(
    //   "RecommendInsertView",
    //   recommendationInsertViewData1?.recommendationInsertViewData?.payload
    //     ?.payload
    // );
    if (!_.isEmpty(recommendationInsertViewData1)) {
      if (recommendationInsertViewData1.status === "success") {
        const list3 = recommendationInsertViewData1.payload.payload;
        if (!_.isEmpty(list3)) {
          setInsertRecommendView(list3);
        }
      }
    }
  }, [recommendationInsertViewData1]);

  useEffect(() => {
    dispatch(showBuyModal({ isShow: false }));
  }, []);

  useEffect(() => {
    if (closeModal) {
      setConfirmModal(false);
    }
  }, [closeModal]);

  useEffect(() => {
    if (!confirmModal) {
      setCloseModal(false);
    }
  }, [confirmModal]);

  useEffect(() => {
    // console.log("assignCourse", assignCourse, courseData);
    if (assignCourse?.status === "success" && !_.isEmpty(courseData)) {
      // `/moduleDetail/${course?.crscd}/?source=${course?.source}`
      dispatch(getAssignCourseClear());
      goToModuleDetail(courseData)
      // goToModuleDetail(courseData?.crscd, courseData?.source, courseData.id ? courseData.id : courseData?.wc_post_id)
      // navigate(
      //   `/moduleDetail/${courseData?.crscd}/?source=${courseData?.source}&cid=${courseData.id ? courseData.id : courseData?.wc_post_id}`
      // );
    }
  }, [assignCourse, courseData]);

  useEffect(() => {
    // console.log('assignBrokerCourse', assignBrokerCourse)
    if (assignBrokerCourse?.status === "success" && !_.isEmpty(courseData)) {
      // `/moduleDetail/${course?.crscd}/?source=${course?.source}`
      dispatch(getAssignBrokerCourseClear());
      // navigate(
      //   `/moduleDetail/${courseData?.crscd}/?source=${courseData?.source}&cid=${courseData.id ? courseData.id : courseData?.wc_post_id}`
      // );
    }
  }, [assignBrokerCourse])

  const goToModuleDetail = (courseData) => {
    let url = `/moduleDetail/${courseData?.crscd}/?source=${courseData?.source}&cid=${courseData.id ? courseData.id : courseData?.wc_post_id}`
    if (isMobile) {
      let key = CONFIG.KEY.MOBILE_ACCESS_KEY
      let token = localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
      let userId = authBroker.payload.user.user_id
      let username = authBroker.payload.user.user_id
      let email = authBroker.payload.user.email
      let color1 = authBroker.payload.user.branding_primary_color_1 ?
        authBroker.payload.user.branding_primary_color_1 : CONFIG.COLOR_ELEMENT_1
      let color2 = authBroker.payload.user.branding_primary_color_2 ?
        authBroker.payload.user.branding_primary_color_2 : CONFIG.COLOR_ELEMENT_2
      url = `/courseModuleListing/${courseData?.crscd}/?source=${courseData?.source}&cid=${courseData.id ? courseData.id : courseData?.wc_post_id}`
      url = url + `&key=${key}&token=${token}&user_id=${userId}`
      url = url + `&username=${username}&webView=true&email=${email}`
      url = url + `&color_1=${color1}&color_2=${color2}`
    }
    if (courseData.course_categoryId) {
      url = url + `&catId=${courseData.course_categoryId}&via_cat=true`
    } else if (courseData.isLevel) {
      url = url + `&lp_id=${courseData.lp_id}&via_lp=true&is_level=true&level_id=${courseData.level_id}`
    } else if (courseData.lp_id) {
      url = url + `&lp_id=${courseData.lp_id}&via_lp=true`
    }
    sessionStorage.setItem('moduleForTour', url);
    navigate(url);
  }

  const setCourseDetailData = (course) => {
    let startOffer = moment(course["start_date_&_time_of_offer"], "YYYY-MM-DD");
    let endOffer = moment(course["end_date_&_time_of_offer"], "YYYY-MM-DD");
    let tempObj = {
      payload: {
        course_code: course.crscd,
        course_discount: course.discount,
        course_duration: course.duration,
        course_lessons: course.lessons,
        course_period: course.durationUnit,
        course_views: course.views,
        product_description: course.long_description,
        product_id: course.id,
        product_name: course.name,
        product_price: course.market_price,
        product_regular_price: course.market_price,
        product_sale_price: course.selling_price,
        product_short_description: course.short_description,
        product_slug: course.name,
        product_thumbnail: course.imageURL,
        product_total_sales: course.market_price,
        sfdc_product_type: course.sfdc_product_type,
        course_list: _.isArray(course.course_list) ? course.course_list : [],
        product_basic_price: course.product_basic_price,
        product_premium_price: course.product_premium_price,
        product_offer_for_basic: course.product_offer_for_basic,
        product_offer_for_premium: course.product_offer_for_premium,
        start_date_time_of_offer: course["start_date_&_time_of_offer"],
        end_date_time_of_offer: course["end_date_&_time_of_offer"],
        offer_available: moment().isBetween(startOffer, endOffer),
      },
      status: "success",
    };
    dispatch(courseDetailResponse(tempObj));
  };

  const redirectToPage = (course) => {
    console.log("course", course);
   
    // console.log("course 2");
    if (course?.source === "ecom" && !course?.is_paid) {
      // console.log("course 3");
      if (sessionStorage.getItem(SessionKeys.IS_TOUR) === "YES") {
        return;
      }
      setCourseDetailData(course);
      navigate(`/shopping/${course.id}/?addToCart=${course?.is_addtocart}`);
    } else if (
      course?.is_paid === "" ||
      course?.is_paid === undefined ||
      course?.is_paid
    ) {
      // console.log("course 4");
      clickStreamUser("course_card_click_goto_course", {
        courseId: course?.id,
        courseName: course?.name,
        userId: authBroker?.payload?.user.user_id,
        courseCode: course?.crscd,
      });
      if (course?.source === "broker") {
        setCourseData(course);
        // console.log("course redirect to module");
        // dispatch(
        //   getAssignBrokerCourse({
        //     module: "assignedCourseBroker",
        //     postData: {
        //       token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        //       entity_type: "courses",
        //       entity_id: course?.wc_post_id ? _.toNumber(course?.wc_post_id) : course?.id,
        //       origin: "broker",
        //       $number_of_days: "",
        //       is_type: "free",
        //     },
        //   })
        // );

        // console.log("course 5");
        // navigate(
        //   `/moduleDetail/${course?.crscd}/?source=${course?.source}`
        // );
        goToModuleDetail(course);

      } else {
        // console.log("course redirect to assign", course);

        setCourseData(course);
        goToModuleDetail(course);
        // if (isLoggedIn) {
        //   dispatch(
        //     getAssignCourse({
        //       module: "assign-course",
        //       postData: {
        //         user_id: authBroker?.payload?.user.user_id,
        //         course_id: course?.crscd,
        //       },
        //     })
        //   );
        //   dispatch(
        //     getAssignBrokerCourse({
        //       module: "assignedCourseBroker",
        //       postData: {
        //         token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        //         entity_type: "courses",
        //         entity_id: course?.crscd,
        //         origin: "xsel",
        //         number_of_days: course?.course_days,
        //         is_type: course?.is_free ? "free" : "paid",
        //         comment: course?.name,
        //       },
        //     })
        //   );
  
        //   dispatch(
        //     recommendationInsertViewData({
        //       module: "myInsertViewRecommendation",
        //       postData: {
        //         product_id: _.toNumber(course.id),
        //         email: authBroker?.payload?.user?.email,
        //       },
        //     })
        //   );
        // } else {
        //   goToModuleDetail(course);
        // }
      }
    }
  };

  const goToVideoDetail = (m) => {
    clickStreamUser("video-in-lp-view-button-clicked", {
      userId: authBroker?.payload?.user.user_id,
      title: m?.product_name
    });
    // steVideoData(m)
    dispatch(setMarkView({
      module: 'setMarkView',
      postData: {
        token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        entity_type: 'videos',
        entity_id: (m?.source === "xsel") ? m?.crscd : m?.id,
        origin: (m?.source === "xsel") ? "xsel" : "broker",
        is_type: m?.is_paid ? 'paid' : 'free',
        comment: (m?.source === "xsel") ? m?.name : ""
      }
    }))

    let courseId = (m.source === "xsel") ? m.crscd : m.id
    
    let paramsReq ={
      code: courseId,
      source: m?.source,
    }
    if (m.course_categoryId) {
      paramsReq.catId = m.course_categoryId;
      paramsReq.via_cat = "true"
    } else if (m.isLevel) {
      paramsReq.lp_id = m.lp_id;
      paramsReq.via_lp = "true";
      paramsReq.is_level = "true";
      paramsReq.level_id = m.level_id;
    } else if (m.lp_id) {
      paramsReq.lp_id = m.lp_id;
      paramsReq.via_lp = "true";
    }

    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);

    // let url = `/video-view-page/${m?.id}/?source=${m?.source}&code=${courseId}&catId=`
    // if (m.course_categoryId) {
    //   url = url + `&catId=${m.course_categoryId}&via_cat=true`
    // } else if (m.isLevel) {
    //   url = url + `&lp_id=${m.lp_id}&via_lp=true&is_level=true&level_id=${m.level_id}`
    // } else if (m.lp_id) {
    //   url = url + `&lp_id=${m.lp_id}&via_lp=true`
    // }
    let url = `/video-view-page/${m?.id}/?c=${encodedUrl}`
    navigate(url)

  }

  const renderPremiumTag = (course) => {
    return course.is_paid !== undefined && !course.is_paid ? (
      <div className={course?.is_addtocart ? "d-flex justify-content-between revisit_icon buTN_buy added-in-cart" : "d-flex justify-content-between revisit_icon buTN_buy"}>
        <div className="calendar_event">
          <button
            type="button"
            className="btn btn-primary-LR  setup-button"
            disabled={sessionStorage.getItem(SessionKeys.IS_TOUR) === "YES" ? true : false}
            onClick={() => {
              if (sessionStorage.getItem(SessionKeys.IS_TOUR) === "YES") {
                return;
              }
              // console.log("COURSEDATA", course);
              if (isMobile) {
                let data = JSON.stringify({
                  type: 'shopping',
                  id: course.id,
                  course_id: course.id
                })
                webViewCallbackHandler(data)
              } else {
                setCourseDetailData(course);
                navigate(
                  `/shopping/${course.id}?addToCart=${course?.is_addtocart}`
                );
              }
            }}
          >
            {course?.is_addtocart ? "Added" : "Buy"}
          </button>
        </div>
      </div>
    ) : (
      ""
    );
  };

  const renderCourseCard = (course, i) => {
    return (
      <>
        <div
          className={`col-md-6 col-lg-4 ${course.isLevel || isSearch === true ? "col-xl-3" : "col-xl-4"} col-12 mb-4 broker-box`}
          key={"course-" + i}
        >
          <div id={course?.id} className="img-box_nw">
            <div
              className={`img-videosec learn_image-card ${course.isLock
                ? "cursor-not-allowed"
                : "cursor-pointer"
                }`}
              onClick={() => {
                if (!course.isLock) {
                  if (course?.level_entity_type !== "video") {
                    redirectToPage(course);
                  } else {
                    goToVideoDetail(course)
                  }
                }
              }}
              title={course.is_manager_checklist ? 'Notification sent to your manager, please discuss before moving forward.' : ""}
            >
              {pageType === "course" || pageType === "myCourse" ? (
                <>
                  {/* <img
                    className={`img-fluid galleryImg_lern ${course.isLock ? "grayscale" : ""
                  }`}
                    src={course.imageURL}
                    onClick={() => {
                      redirectToPage(course);
                    }}
                    onError={({currentTarget}) => {
                      currentTarget.onerror = true;
                      currentTarget.src = "/images/default-demo-img.jpg"
                    }}
                  /> */}
                  <ImageComponent
                    name={course.name}
                    thumbnail={course.imageURL ? course.imageURL : ""}
                    cssClass={`img-fluid galleryImg_lern ${course.isLock ? "grayscale" : ""}`}
                    errorClass={`img-fluid galleryImg_lern ${course.isLock ? "grayscale" : ""}`}
                    handleClick={() => {
                      if (!course.isLock) {
                        if (course?.level_entity_type !== "video") {
                          redirectToPage(course);
                        } else {
                          goToVideoDetail(course)
                        }
                      }
                    }}
                  />
                  {course?.level_entity_type === "video" && <div className="playbtnvideo">
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
                      <g id="Group_5737" data-name="Group 5737" transform="translate(-251 -1026)">
                        <g id="Group_2568" data-name="Group 2568" transform="translate(7.795 7.795)">
                          <g id="Ellipse_200" data-name="Ellipse 200" transform="translate(243.205 1018.205)" fill="#febe10" stroke="#fff" strokeWidth="4">
                            <circle cx="24" cy="24" r="24" stroke="none" />
                            <circle cx="24" cy="24" r="22" fill="none" />
                          </g>
                        </g>
                        <path id="Polygon_3" data-name="Polygon 3" d="M10,0,20,14H0Z" transform="translate(284 1040) rotate(90)" fill="#6941C6" />
                      </g>
                    </svg>
                  </div>}
                  {course.crs_progress !== undefined &&
                    course.crs_progress != null &&
                    course.crs_progress > 0 ? (
                    <a href="#">
                      <span
                        data-bs-toggle="modal"
                        data-bs-target="#premium-contentpopu"
                      >
                        <span className="lear_icon">
                          {
                            course.crs_progress >= 100 ? (
                              <svg id="Group_2401" data-name="Group 2401" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
                                <circle id="Ellipse_16" data-name="Ellipse 16" cx="13" cy="13" r="13" fill="#fff" />
                                <path id="Icon_material-done" data-name="Icon material-done" d="M11.2,19.606,8.264,17.04l-1.37,1.37L11.2,22.346l9.823-10.179-1.37-1.37Z" transform="translate(-0.966 -3.287)" fill="#00b70e" stroke="#00b70e" strokeWidth="2" />
                              </svg>
                            )
                              : (
                                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
                                  <g id="Group_2850" data-name="Group 2850" transform="translate(0.822 0.822)">
                                    <circle id="Ellipse_16" data-name="Ellipse 16" cx="13" cy="13" r="13" transform="translate(-0.822 -0.822)" fill="#fff" />
                                    <path id="Path_3181" data-name="Path 3181" d="M0,0,4.762,5.514,0,10.944" transform="translate(7.24 6.706)" fill="none" stroke="#0fb41c" strokeWidth="3" />
                                    <path id="Path_3182" data-name="Path 3182" d="M0,0,4.762,5.514,0,10.944" transform="translate(13.543 6.706)" fill="none" stroke="#0fb41c" strokeWidth="3" />
                                  </g>
                                </svg>
                              )}
                          {/* <img
                            src={
                              course.crs_progress >= 100
                                ? "/images/check.png"
                                : "/images/forward.png"
                            }
                          /> */}
                        </span>
                      </span>
                    </a>
                  ) : (
                    ""
                  )}
                  {course.isLock ? (
                    <span className="lear_icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" title={course.is_manager_checklist ? 'Notification sent to your manager, please discuss before moving forward.' : ""}>
                        <g id="Locked" transform="translate(0.604 0.822)">
                          <circle id="Ellipse_16" data-name="Ellipse 16" cx="13" cy="13" r="13" transform="translate(-0.604 -0.822)" fill="#fff" />
                          <g id="Group_5144" data-name="Group 5144" transform="translate(8.04 5.482)">
                            <path id="Path_3397" data-name="Path 3397" d="M27.215,17.114H25.6V14.757a2.743,2.743,0,1,0-5.487,0v2.356H18.5V14.757a4.357,4.357,0,1,1,8.715,0Z" transform="translate(-18.5 -10.4)" fill="#707070" />
                          </g>
                          <g id="Group_5145" data-name="Group 5145" transform="translate(6.587 10.194)">
                            <path id="Path_3400" data-name="Path 3400" d="M24.651,25H14.968a.951.951,0,0,0-.968.968V32.1a.951.951,0,0,0,.968.968h9.683a.951.951,0,0,0,.968-.968V25.968A.951.951,0,0,0,24.651,25Zm-4.2,4.648v.839a.646.646,0,1,1-1.291,0v-.839a1.284,1.284,0,1,1,1.937-1.1A1.212,1.212,0,0,1,20.455,29.648Z" transform="translate(-14 -25)" fill="#707070" />
                          </g>
                        </g>
                      </svg>
                      {/* <img src="/images/Layer_1.png"
                        alt="lock"
                        title={course.is_manager_checklist ? 'Notification sent to your manager, please discuss before moving forward.' : ""} /> */}
                    </span>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                <video width="100%" height="128" controls="">
                  <source src={course.mp4Link} type="video/mp4" />
                  <source src={course.oggLink} type="video/ogg" />
                  Your browser does not support the video tag.
                </video>
              )}
              {course.is_paid && (
                <ProgressBar
                  className="custom_progress_barr custom_bartwoRealtor"
                  variant="success"
                  now={course.crs_progress ? course.crs_progress : 0}
                />
              )}
            </div>

            <div className="details-card_nw">
              <h5
                className={`${course.isLock
                  ? "cursor-not-allowed"
                  : "cursor-pointer"
                  }`}
                onClick={() => {
                  if (!course.isLock) {
                    if (course?.level_entity_type !== "video") {
                      redirectToPage(course);
                    } else {
                      goToVideoDetail(course)
                    }
                  }
                }}
              >
                <a
                  className="course-head-al_search"
                  title={course?.name?.replace("&amp;", "&").replace('&amp;&amp;', '&&')}
                  dangerouslySetInnerHTML={{
                    __html: course?.name,
                  }}
                ></a>
              </h5>

              <div className="row info-bottm-card_nw">
                <div className="col-md-12 cou_cardIcon">
                  <div className="fgf">
                    {course?.level_entity_type !== "video" ? <p>
                      <span>{course.lessons} </span>
                      {course.lessons === 1 ? "Module" : "Modules"}
                    </p> : ""}
                    {pageType === "myCourse" ? (
                      course.due_date ?
                        <div className="assignbox">
                          {/*course?.assigned_by === "" ? (
                          <p></p>
                        ) : (
                          <p>
                            Assigned By: <strong>{course?.assigned_by}</strong>
                          </p>
                        )*/}
                          <p>
                            <span className="fw-normals">Due By{" "}</span>
                            <strong>
                              {moment(course?.due_date, "MM/DD/YYYY").format(
                                "DD MMM, YYYY"
                              )}
                            </strong>
                          </p>
                        </div> : ""
                    ) : (
                      <div className="assignbox"></div>
                    )}
                    <div className="assignbox"></div>
                  </div>
                  <div className="carouseL_Iconno2 d-flex flex-column">
                    <div className="ico__imG01 d-flex">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                      >
                        <path
                          id="clock-time-four"
                          d="M10,2a8,8,0,1,0,8,8,8.024,8.024,0,0,0-8-8m3.44,10.56L9.2,10.24V6h1.2V9.52l3.6,2Z"
                          transform="translate(-2 -2)"
                          fill="#6941C6"
                        />
                      </svg>
                      <p>
                        {" "}
                        <span>{course.duration}</span> {course.durationUnit}
                      </p>
                    </div>
                    <div className="ico_texxt02 d-flex pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                      >
                        <path
                          id="eye-circle"
                          d="M10,8a2,2,0,1,0,2,2,2,2,0,0,0-2-2m0,2.8a.8.8,0,1,1,.8-.8.8.8,0,0,1-.8.8M10,8a2,2,0,1,0,2,2,2,2,0,0,0-2-2m0,2.8a.8.8,0,1,1,.8-.8.8.8,0,0,1-.8.8M10,2a8,8,0,1,0,8,8,8,8,0,0,0-8-8m0,11.2A5.178,5.178,0,0,1,5.2,10a5.2,5.2,0,0,1,9.6,0A5.178,5.178,0,0,1,10,13.2M10,8a2,2,0,1,0,2,2,2,2,0,0,0-2-2m0,2.8a.8.8,0,1,1,.8-.8A.8.8,0,0,1,10,10.8Z"
                          transform="translate(-2 -2)"
                          fill="#6941C6"
                        />
                      </svg>
                      <p>
                        <span>{course.views}</span> View
                        {course.views > 1 ? "s" : ""}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row infoIcon_nw">
                <div className="col-md-12 d-flex justify-content-between align-items-center action_learning02 action_learning">
                  {/* {course?.provider?.provider_img !== "" ? (
                    <img
                      src={course?.provider?.provider_img}
                      alt=""
                      title={course?.provider?.provider_display_name}
                    />
                  ) : (
                    <div className="d-flex carouseL_IconnBY">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                      >
                        <path
                          id="Exclusion_3"
                          data-name="Exclusion 3"
                          d="M21486.014-926.971a11.938,11.938,0,0,1-8.5-3.519,11.932,11.932,0,0,1-3.52-8.5,11.932,11.932,0,0,1,3.52-8.5,11.938,11.938,0,0,1,8.5-3.519,11.938,11.938,0,0,1,8.5,3.519,11.932,11.932,0,0,1,3.52,8.5,11.932,11.932,0,0,1-3.52,8.5A11.938,11.938,0,0,1,21486.014-926.971Zm.146-15.8,2.725,4.543v2.725h1.877v-2.811l2.682-4.456h-2.066l-1.516,2.8-1.564-2.8Zm-6.734,0h0v7.267h3.178a5.257,5.257,0,0,0,1.307-.135,2.731,2.731,0,0,0,.943-.459,1.955,1.955,0,0,0,.584-.691,2.082,2.082,0,0,0,.209-.939,1.653,1.653,0,0,0-.414-1.176,2.017,2.017,0,0,0-1.129-.583v-.043a1.78,1.78,0,0,0,.783-.626,1.6,1.6,0,0,0,.275-.928,1.605,1.605,0,0,0-.2-.809,1.431,1.431,0,0,0-.619-.566,2.9,2.9,0,0,0-.8-.259,10.487,10.487,0,0,0-1.289-.054h-2.822Zm2,5.935h-.135v-1.813h.41l.418,0h.006l.381,0a2.429,2.429,0,0,1,.6.07.8.8,0,0,1,.453.281.886.886,0,0,1,.135.534,1.009,1.009,0,0,1-.107.469.806.806,0,0,1-.4.324,1.631,1.631,0,0,1-.631.124C21482.334-936.834,21481.953-936.834,21481.428-936.834Zm.156-3.065h-.291v-1.538h.178c.365,0,.652,0,.857.005a1.5,1.5,0,0,1,.508.086.548.548,0,0,1,.318.27.752.752,0,0,1,.092.362,1.053,1.053,0,0,1-.076.41.616.616,0,0,1-.334.291,1.4,1.4,0,0,1-.49.1C21482.135-939.9,21481.879-939.9,21481.584-939.9Z"
                          transform="translate(-21473.998 951.002)"
                          fill="#6941C6"
                          opacity="1"
                        ></path>
                      </svg>
                      <p>
                        {" "}
                        <span
                          className="sub_txt_lern"
                          title={`${
                            course?.provider?.provider_display_name ===
                            "A Lady's Touch Inc"
                              ? `${course?.provider?.provider_display_name}.`
                              : course?.provider?.provider_display_name
                          }`}
                        >
                          {course?.provider?.provider_display_name?.length > 11
                            ? course?.provider?.provider_display_name?.substring(
                                0,
                                11
                              ) + "..."
                            : course?.provider?.provider_display_name}
                        </span>
                      </p>
                    </div>
                  )} */}
                  <ProviderComponent providerData={course.provider} />

                  {course.level_entity_type === "video" ?
                    <button type="button" className={`btn btn-primary-LR  setup-button ${course.isLock
                      ? "cursor-not-allowed"
                      : "cursor-pointer"
                      }`}
                      onClick={() => {
                        if (!course.isLock) {
                          goToVideoDetail(course)
                        }
                      }
                      }
                      disabled={course.isLock ? true : false}
                    >View</button>
                    :
                    course.source !== "ecom" ||
                      course.is_paid ||
                      !course.showBuy ? (
                      <div
                        className={`d-flex justify-content-between revisitIconcon comp4530 ${course.isLock
                          ? "cursor-not-allowed"
                          : "cursor-pointer"
                          }`}
                        onClick={() => {
                          if (!course.isLock) {
                            redirectToPage(course);
                          }
                        }}
                      >
                        <img
                          src={
                            course.crs_progress === "" ||
                              course.crs_progress === undefined ||
                              course.crs_progress === null ||
                              course.crs_progress === 0
                              ? "/images/Component 46-78.svg"
                              : course.crs_progress >= 100
                                ? "/images/Component 4427.svg"
                                : "/images/Component 4530.svg"
                          }
                          width="80"
                          height="17"
                          alt=""
                        />
                      </div>
                    ) : (
                      renderPremiumTag(course)
                    )}
                </div>
              </div>
            </div>
          </div>
          {hasDescription ? (
            <div className="learn-content">
              <p>
                {course.description.length < 100
                  ? course.description
                  : course.description.substring(0, 100) + "..."}
              </p>
            </div>
          ) : (
            ""
          )}
        </div>
        <ConfirmModal
          confirmModal={confirmModal}
          setConfirmModal={setConfirmModal}
          showModalMsg={showModalMsg}
          isConfirm={isConfirm}
          confirmId={courseId}
          confirmAction={setFavoriteCourse}
        />

        <BuyProductModal />
      </>
    );
  };

  const renderSliderCourseCard = (course, i) => {
    return (
      <>
        <div
          className={`col-md-6 col-lg-4 ${course.isLevel || isSearch === true ? "col-xl-3" : "col-xl-4"} col-12 mb-4 broker-box`}
          key={"course-" + i}
        >
          <div id={course?.id} className="img-box_nw position-relative">
            <div className="combo-tag">
              <i className="fa fa-star" aria-hidden="true"></i> COMBO
            </div>
            <Carousel id="courseCardCarousel">
              {course.course_list.map((listData, index) => {
                return (
                  <Carousel.Item key={"listdata-" + index}>
                    <div
                      className="img-videosec learn_image-card cursor-pointer"
                      onClick={() => {
                        if (!course.isLock) {
                          course.showBuy ? redirectToPage(course) : redirectToPage(listData);
                        }
                      }}
                      key={index}
                    >
                      {pageType === "course" || pageType === "myCourse" ? (
                        <>
                          {/* <img
                            className="img-fluid galleryImg_lern"
                            src={listData.imageURL}
                            onClick={() => {
                              if (!course.isLock) {
                              redirectToPage(listData);
                              }
                            }}
                            onError={({currentTarget}) => {
                              currentTarget.onerror = true;
                              currentTarget.src = "/images/default-demo-img.jpg"
                          }}
                          /> */}
                          <ImageComponent
                            name={listData.name}
                            thumbnail={listData.imageURL ? listData.imageURL : ""}
                            cssClass={"img-fluid galleryImg_lern"}
                            errorClass={"img-fluid galleryImg_lern"}
                          />
                        </>
                      ) : (
                        <video width="100%" height="128" controls="">
                          <source src={listData.mp4Link} type="video/mp4" />
                          <source src={listData.oggLink} type="video/ogg" />
                          Your browser does not support the video tag.
                        </video>
                      )}
                    </div>

                    <div className="details-card_nw">
                      <h5
                        className="cursor-pointer"
                        onClick={() => {
                          if (!course.isLock) {
                            course.showBuy ? redirectToPage(course) : redirectToPage(listData);
                          }
                        }}
                      >
                        <a
                          className="course-head-al_search"
                          title={listData.name?.replace('&amp;', '&').replace('&amp;&amp;', '&&')}
                          dangerouslySetInnerHTML={{
                            __html: listData.name,
                          }}
                        ></a>
                      </h5>
                      <div className="row info-bottm-card_nw">
                        <div className="col-md-12 cou_cardIcon">
                          <p>
                            <span>{listData.lessons} </span>Modules
                          </p>

                          <div className="carouseL_Iconno2 d-flex flex-column">
                            <div className="ico__imG01 d-flex">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  id="clock-time-four"
                                  d="M10,2a8,8,0,1,0,8,8,8.024,8.024,0,0,0-8-8m3.44,10.56L9.2,10.24V6h1.2V9.52l3.6,2Z"
                                  transform="translate(-2 -2)"
                                  fill="#6941C6"
                                />
                              </svg>
                              <p>
                                {" "}
                                <span>{listData.duration}</span>{" "}
                                {listData.durationUnit}
                              </p>
                            </div>
                            <div className="ico_texxt02 d-flex pt-2">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path id="eye-circle" d="M10,8a2,2,0,1,0,2,2,2,2,0,0,0-2-2m0,2.8a.8.8,0,1,1,.8-.8.8.8,0,0,1-.8.8M10,8a2,2,0,1,0,2,2,2,2,0,0,0-2-2m0,2.8a.8.8,0,1,1,.8-.8.8.8,0,0,1-.8.8M10,2a8,8,0,1,0,8,8,8,8,0,0,0-8-8m0,11.2A5.178,5.178,0,0,1,5.2,10a5.2,5.2,0,0,1,9.6,0A5.178,5.178,0,0,1,10,13.2M10,8a2,2,0,1,0,2,2,2,2,0,0,0-2-2m0,2.8a.8.8,0,1,1,.8-.8A.8.8,0,0,1,10,10.8Z" transform="translate(-2 -2)" fill="#6941C6"></path></svg>
                              <p>
                                <span>{listData.views}</span> View
                                {listData.views > 1 ? "s" : ""}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row infoIcon_nw">
                        <div className="col-md-12 d-flex justify-content-between align-items-center action_learning02 action_learning">
                          {/* {listData?.provider?.provider_img !== "" ? (
                            <img src={listData?.provider?.provider_img} alt="" /> //"/images/card_x_icon.png"
                          ) : (
                            <div className="d-flex carouseL_IconnBY">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  id="Exclusion_3"
                                  data-name="Exclusion 3"
                                  d="M21486.014-926.971a11.938,11.938,0,0,1-8.5-3.519,11.932,11.932,0,0,1-3.52-8.5,11.932,11.932,0,0,1,3.52-8.5,11.938,11.938,0,0,1,8.5-3.519,11.938,11.938,0,0,1,8.5,3.519,11.932,11.932,0,0,1,3.52,8.5,11.932,11.932,0,0,1-3.52,8.5A11.938,11.938,0,0,1,21486.014-926.971Zm.146-15.8,2.725,4.543v2.725h1.877v-2.811l2.682-4.456h-2.066l-1.516,2.8-1.564-2.8Zm-6.734,0h0v7.267h3.178a5.257,5.257,0,0,0,1.307-.135,2.731,2.731,0,0,0,.943-.459,1.955,1.955,0,0,0,.584-.691,2.082,2.082,0,0,0,.209-.939,1.653,1.653,0,0,0-.414-1.176,2.017,2.017,0,0,0-1.129-.583v-.043a1.78,1.78,0,0,0,.783-.626,1.6,1.6,0,0,0,.275-.928,1.605,1.605,0,0,0-.2-.809,1.431,1.431,0,0,0-.619-.566,2.9,2.9,0,0,0-.8-.259,10.487,10.487,0,0,0-1.289-.054h-2.822Zm2,5.935h-.135v-1.813h.41l.418,0h.006l.381,0a2.429,2.429,0,0,1,.6.07.8.8,0,0,1,.453.281.886.886,0,0,1,.135.534,1.009,1.009,0,0,1-.107.469.806.806,0,0,1-.4.324,1.631,1.631,0,0,1-.631.124C21482.334-936.834,21481.953-936.834,21481.428-936.834Zm.156-3.065h-.291v-1.538h.178c.365,0,.652,0,.857.005a1.5,1.5,0,0,1,.508.086.548.548,0,0,1,.318.27.752.752,0,0,1,.092.362,1.053,1.053,0,0,1-.076.41.616.616,0,0,1-.334.291,1.4,1.4,0,0,1-.49.1C21482.135-939.9,21481.879-939.9,21481.584-939.9Z"
                                  transform="translate(-21473.998 951.002)"
                                  fill="#6941C6"
                                  opacity="1"
                                ></path>
                              </svg>
                              <p>
                                {" "}
                                <span
                                  className="sub_txt_lern"
                                  title={
                                    listData?.provider?.provider_display_name
                                  }
                                >
                                  {listData?.provider?.provider_display_name
                                    ?.length > 11
                                    ? listData?.provider?.provider_display_name?.substring(
                                        0,
                                        11
                                      ) + "..."
                                    : listData?.provider?.provider_display_name}
                                </span>
                              </p>
                            </div>
                          )} */}
                          <ProviderComponent providerData={listData.provider} />

                          {course.source !== "ecom" ||
                            course.is_paid ||
                            !course.showBuy ? (
                            <div
                              className={`d-flex justify-content-between revisitIconcon comp4530 ${course.isLock
                                ? "cursor-not-allowed"
                                : "cursor-pointer"
                                }`}
                              onClick={() => {
                                if (!course.isLock) {
                                  course.showBuy ? redirectToPage(course) : redirectToPage(listData);
                                }
                              }}
                            >
                              <img
                                src={
                                  course.crs_progress === undefined ||
                                    course.crs_progress === null ||
                                    course.crs_progress === 0
                                    ? "/images/Component 46-78.svg"
                                    : course.crs_progress >= 100
                                      ? "/images/Component 4427.svg"
                                      : "/images/Component 4530.svg"
                                }
                                width="80"
                                height="17"
                                alt=""
                              />
                            </div>
                          ) : (
                            renderPremiumTag(course)
                          )}
                        </div>
                      </div>
                    </div>
                  </Carousel.Item>
                );
              })}
            </Carousel>
            <div className="position-absolute course-length-bar">
              <span>{course.course_list.length}</span> item{course.course_list.length > 1 ? 's' : ''}
            </div>
          </div>
          {hasDescription ? (
            <div className="learn-content">
              <p>
                {course.description.length < 100
                  ? course.description
                  : course.description.substring(0, 100) + "..."}
              </p>
            </div>
          ) : (
            ""
          )}
        </div>
        <ConfirmModal
          confirmModal={confirmModal}
          setConfirmModal={setConfirmModal}
          showModalMsg={showModalMsg}
          isConfirm={isConfirm}
          confirmId={courseId}
          confirmAction={setFavoriteCourse}
        />

        <BuyProductModal />
      </>
    );
  };

  return coursesList?.length === 0
    ? "No courses found"
    : coursesList.map((course, i) => {
      if (
        course.is_bundle &&
        course.course_list &&
        _.isArray(course.course_list) &&
        course.course_list.length > 0
      ) {
        return renderSliderCourseCard(course, i);
      } else {
        return renderCourseCard(course, i);
      }
    });
  
};

export default CourseCardListBody;
